const React = require('react');
const copy = require('copy-to-clipboard');
const ReactIntl = require('react-intl');
const { isEmpty, partial } = require('lodash');

const { Text, Input, Button, Layout, Modal, ModalContent, ModalHeader, IconButton } = require('@metro-ui/core');
const { Back } = require('@metro-ui/icons');

const { generate, buildTotpURL } = require('./QRCodeGenerator.js');
const defaultMessages = require('../../i18n/messages/default');
const LoginStore = require('../../stores/LoginStore');
const LoginActions = require('../../actions/LoginActions');
const Utils = require('../../utils/Utils.js');
const ErrorCodes = require('../../utils/ErrorCodes.js');

const { injectIntl } = ReactIntl;

class SetupCodesViaAppModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      code: '',
      appName: '',
      displayQrCode: true
    }

    this.validateTotpListener = this.validateTotpListener.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
    this.onVerifyClick = this.onVerifyClick.bind(this);
    this.onToggleQrCodeMode = this.onToggleQrCodeMode.bind(this);
    this.onCopyClipboard = this.onCopyClipboard.bind(this);
    this.onBackNavigationClick = this.onBackNavigationClick.bind(this);
  }

  componentDidMount() {
    LoginStore.totpAppValidationListener(this.validateTotpListener);
  }

  componentWillUnmount() {
    LoginStore.removeTotpAppValidationListener(this.validateTotpListener);
  }

  validateTotpListener() {
    const appState = LoginStore.getState();
    const { validateTotpResponse } = appState;
    if (validateTotpResponse.isValid) {
      LoginActions.triggerToast(this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.codes_via_app.msg_setup_successful']), "success", true);
      LoginActions.getUserMFAMethods(this.props.idToken, this.props.countryCode); // refresh the 2FA list
      this.props.onNavItemClick(2, true); //pass true to GetUserDetails
      this.props.closeModal()
    } else {
      if (validateTotpResponse.errorCode) {
        if (validateTotpResponse.errorCode === '0203205') {
          LoginActions.triggerToast(Utils.replaceAllByKeys(this.props.intl.formatMessage(defaultMessages[ErrorCodes[appState.validateTotpResponse.errorCode]]), appState.validateTotpResponse.placeholders), "error", true)
          this.props.closeModal()
        } else {
          LoginActions.triggerToast(Utils.replaceAllByKeys(this.props.intl.formatMessage(defaultMessages[ErrorCodes[appState.validateTotpResponse.errorCode]]), appState.validateTotpResponse.placeholders), "error", true)
        }
      } else {
        LoginActions.triggerToast(this.props.intl.formatMessage(defaultMessages['loginpreferences.unknown_auth_token']), "error", true);
        this.props.closeModal()
      }
    }
  }

  onInputChange(field, _, value) {
    if (field === 'code' && value.length > 6)
      value = value.slice(0, 6)
    this.setState({ [field]: value });
  }

  onVerifyClick() {
    LoginActions.validateAddTotpAddCode(
      this.props.idToken,
      this.props.userType,
      this.props.realmId,
      this.props.countryCode,
      this.props.traceId,
      this.state.code,
      '',
      this.props.localeId,
      this.props.authMethod,
      this.state.appName
    );
    // Pass mobile number as '' only when OTP media type is NOT SMS 
  }

  onToggleQrCodeMode() {
    this.setState({ displayQrCode: !this.state.displayQrCode });
  }

  onCopyClipboard() {
    copy(this.props.twoFactorAuthInfo.sharedTempSecret);
  }

  onBackNavigationClick() {
    this.props.closeModal();
  }

  render() {
    const codePlaceholder = this.props.intl.formatMessage(defaultMessages['loginpreferences.code']);
    const authAppPlaceholder = this.props.intl.formatMessage(defaultMessages['loginpreferences.authApp'])
    const issuer = Utils.formIssuer(this.props.userType);

    let totpUrl = buildTotpURL(this.props.twoFactorAuthInfo.sharedTempSecret,
      this.props.twoFactorAuthInfo.secretValidity,
      this.props.twoFactorAuthInfo.timeStep,
      this.props.twoFactorAuthInfo.algorithmType,
      this.props.email,
      issuer);
    const divStyle = {
      fontSize: "small",
    };

    const imgUrl = generate(totpUrl);
    return (
      <>
        {!isEmpty(this.props.twoFactorAuthInfo) &&
          <Modal
            style={{
              'width': '27vw',
              'height': '75vh'
            }}
            aria-labelledby="modal-title"
            isOpen
            onDismiss={() => {
              this.props.closeModal();
            }}
          >
            <ModalHeader
              align="end"
              isClosable
              padding="medium"
              spacing="medium"
            >
              <IconButton
                Icon={Back}
                hasNoInteractionEffect
                label="Back"
                color="metro-blue"
                onClick={this.props.onBackNavigationClick}
              />
              {this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.codes_via_app.setup_multiple_2fa'])}
            </ModalHeader>
            <ModalContent
              direction="column"
              padding="xx-large"
              spacing="medium"
            >
              <Text className="margin-bottom-small" size="medium">
                <strong>{this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.codes_via_app.step_0_multiple_2fa'])}</strong>
              </Text>
              <Text className="margin-bottom-small" size="medium">
                {this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.codes_via_app.step_1_multiple_2fa'])}</Text>
              <div className="two-fa-form-controls">
                <Input
                  placeholder={authAppPlaceholder}
                  onChange={partial(this.onInputChange, 'appName')}
                  triggerInputPulseAnimation
                  isRequired
                />
              </div>
              <Text className="margin-bottom-small" hasNoNativeMargin> {this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.codes_via_app.step_2_multiple_2fa'])} </Text>
              <Text className="margin-bottom-small" size="medium">
                {this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.codes_via_app.step_3_multiple_2fa'])}
              </Text>
              {this.state.displayQrCode && <div className="margin-bottom-small">
                <img className="qrcode" src={imgUrl} alt="HTML5" />
              </div>}
              {!this.state.displayQrCode && <Layout align="end" spacing="medium">
                <Layout grow={1}>
                  <Input isReadOnly style={divStyle}
                    defaultValue={this.props.twoFactorAuthInfo.sharedTempSecret}
                    iconPosition="left" />
                </Layout>

                <Button size="medium" isWide onClick={this.onCopyClipboard}
                  variant="primary">
                  {this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.codes_via_app.qr_code_copy_to_clipboard'])}
                </Button>

              </Layout>}

              <Text className="margin-bottom-small" size="medium">
                {this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.codes_via_app.step_4_multiple_2fa'])}
              </Text>

              <div className="two-fa-form-controls">
                <Input
                  placeholder={codePlaceholder}
                  type="number"
                  value={this.state.code}
                  onChange={partial(this.onInputChange, 'code')}
                  triggerInputPulseAnimation
                  isRequired
                />
              </div>
              <div className="two-fa-form-controls">
                <Button size='medium'
                  isWide
                  isDisabled={this.state.code.length <= 5}
                  onClick={this.onVerifyClick.bind(this)}
                  variant='primary'>
                  {this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.codes_via_app.verify'])}
                </Button>
              </div>
            </ModalContent>

          </Modal>
        }
      </>
    );
  }
};

module.exports = injectIntl(SetupCodesViaAppModal);